
export class GralMon {
  id: number;
  simbolo: string;
  claveS: string;
}
